<template>
    <div class="login">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="login-wrap d-md-flex">
                    <div class="login-img"></div>
                    <div class="login-box p-4 p-md-5">
                        <div class="login-logo mb-3 d-flex justify-content-center flex-column">
                            <img
                                src="../assets/brand/logo_gastouderapp.svg"
                                alt="Gastouderapp logo"
                            />
                        </div>
                        <h6 class="fw-bold">Nieuw wachtwoord instellen</h6>
                        <p>Voer hieronder een nieuw wachtwoord in en bevestig dit.</p>
                        <div class="mb-4">
                            <div
                                v-if="error && error.error_message"
                                class="alert alert-danger"
                                role="alert"
                            >
                                {{ error.error_message }}
                            </div>
                            <div class="mb-2">
                                <label
                                    class="form-label"
                                    for="passwordNewInput"
                                >Nieuw wachtwoord</label>
                                <div class="input-group">
                                    <input
                                        class="form-control"
                                        id="passwordNewInput"
                                        :type="showPassword ? 'text' : 'password'"
                                        v-model="password"
                                    />
                                    <button
                                        class="btn"
                                        type="button"
                                        @click="togglePassword"
                                    >
                                        <i :class="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="mb-4">
                                <label
                                    class="form-label"
                                    for="passwordRepeatInput"
                                >Herhaal nieuw wachtwoord</label>
                                <div class="input-group">
                                    <input
                                        class="form-control"
                                        id="passwordRepeatInput"
                                        :type="showPassword ? 'text' : 'password'"
                                        v-model="passwordCheck"
                                    />
                                    <button
                                        class="btn"
                                        type="button"
                                        @click="togglePassword"
                                    >
                                        <i :class="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="d-grid">
                                <button
                                    class="btn btn-info mt-3"
                                    v-on:click="resetPassword"
                                >Wijzig wachtwoord</button>
                            </div>
                        </div>
                        <p class="text-center small text-body-secondary mb-2">
                            {{ app.name }} {{ app.tag }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'reset-password-gastouder',
    components: {
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        }
    },
    data() {
        return {
            key1: this.$route.params.key1,
            key2: this.$route.params.key2,
            key3: this.$route.params.key3,
            password: null,
            passwordCheck: null,
            clientNumber: this.$route.params.clientNumber,
            error: null,
            showPassword: false
        }
    },
    created() {
    },
    methods: {
        resetPassword() {
            if (this.passwordCheck !== this.password) {
                this.error = {
                    error_message:
                        'Wachtwoorden komen niet overeen.'
                };
            } else {
                this.error = null
                this.isLoading = true
                this.$request.post('/reset-password', {
                    key1: this.key1,
                    key2: this.key2,
                    key3: this.key3,
                    password: this.password,
                    passwordCheck: this.passwordCheck,
                    client_number: this.clientNumber
                })
                    .then(() => {
                        window.location.href = '/gastouderapp/login/gastouder'
                    })
                    .catch((error) => {
                        this.isLoading = false
                        if (error && error.error) {
                            this.error = error.error
                        } else {
                            this.error = {
                                error_message:
                                    "Er ging iets mis, controleer de verbinding en probeer opnieuw",
                            };
                        }
                    });
            }
        },
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
    }
}
</script>
